import React, { useMemo } from "react"
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom"

import { Toaster } from "react-hot-toast"
// ROUTES

import Login from "routes/Login"
import Logout from "routes/Logout"

import PasswordForgot from "routes/PasswordForgot"
import PasswordReset from "routes/PasswordReset"

import GroupCreate from "routes/groups/create"
import Groups from "routes/groups"
import Group from "routes/groups/[id]"

import IndividualCreate from "routes/individual/create"
import Individuals from "routes/individual"
import Individual from "routes/individual/[id]"

//

import Account from "routes/account"
import Agencies from "routes/agencies"
import Media from "routes/media"
import Passengers from "routes/passengers"
import Users from "routes/users"
import User from "routes/users/[id]"

import { AuthProvider, useAuth } from "hooks/useAuth"
import { ApolloProvider } from "@apollo/client"
import apollo from "./lib/apollo"

const Providers = ({ children }) => {
  const client = useMemo(() => apollo, [apollo])

  return (
    <AuthProvider>
      <ApolloProvider client={client}>{children}</ApolloProvider>
    </AuthProvider>
  )
}

const App = () => {
  return (
    <Providers>
      <Router>
        <Switch>
          <Route exact path="/login">
            <Login />
          </Route>

          <Route exact path="/logout">
            <Logout />
          </Route>

          <Route exact path="/forgot-password">
            <PasswordForgot />
          </Route>

          <Route exact path="/reset-password">
            <PasswordReset />
          </Route>

          {/* TOP ROUTES */}
          <PrivateRoute exact path="/groups/create">
            <GroupCreate />
          </PrivateRoute>

          <PrivateRoute path="/groups/:id">
            <Group />
          </PrivateRoute>

          <PrivateRoute exact path="/groups">
            <Groups />
          </PrivateRoute>

          <PrivateRoute exact path="/individual/create">
            <IndividualCreate />
          </PrivateRoute>

          <PrivateRoute exact path="/individual">
            <Individuals />
          </PrivateRoute>

          <PrivateRoute exact path="/individual/:id">
            <Individual />
          </PrivateRoute>

          {/* SIDE ROUTES */}

          <PrivateRoute exact path="/account">
            <Account />
          </PrivateRoute>

          <PrivateRoute exact path="/agencies">
            <Agencies />
          </PrivateRoute>

          <PrivateRoute exact path="/media">
            <Media />
          </PrivateRoute>

          <PrivateRoute exact path="/passengers">
            <Passengers />
          </PrivateRoute>

          <PrivateRoute exact path="/users">
            <Users />
          </PrivateRoute>

          <PrivateRoute exact path="/users/:id">
            <User />
          </PrivateRoute>

          <PrivateRoute exact path="/">
            <Redirect to="/groups" />
          </PrivateRoute>
        </Switch>
      </Router>

      <Toaster />
    </Providers>
  )
}

function PrivateRoute({ children, ...rest }) {
  const auth = useAuth()

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.loading ? (
          <div className="fixed inset-0 min-h-screen flex justify-center items-center bg-gray-800">
            <div className="loader ">Loading...</div>
          </div>
        ) : auth.user ? (
          children
        ) : (
          <Redirect to={{ pathname: "/login", state: { from: location } }} />
        )
      }
    />
  )
}

export default App
